module.exports = __webpack_public_path__ + "img/cibr-blue.9ac44991.png";